module.exports = __webpack_public_path__ + "assets/img/typeA.16b65ecb.png";